import { render } from "./Niveles.vue?vue&type=template&id=49cc35e2&scoped=true"
import script from "./Niveles.vue?vue&type=script&lang=js"
export * from "./Niveles.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./Niveles.vue?vue&type=style&index=1&id=49cc35e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cc35e2"]])

export default __exports__